import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import {mergeResponse, QueryState} from '../Response';

import Help from '../../../../domain/entities/writer/Help';
import PaginatedResult from '../../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexWriterHelpsSuccess: {
      const result = action.payload as PaginatedResult<Help>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
